
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ssc-banking-thankyou",
      function () {
        return require("private-next-pages/ssc-banking-thankyou/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ssc-banking-thankyou"])
      });
    }
  